import { BaseFetch } from "../main-model"
export default class AnnounceOfBecModel extends BaseFetch {
  getAnnounceOfBecBy = (data) =>
    this.authFetch({
      url: "announce-of-bec/getAnnounceOfBecBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  getAnnounceOfBecById = (data) =>
    this.authFetch({
      url: "announce-of-bec/getAnnounceOfBecById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateAnnounceOfBecById = (data) =>
    this.authFetch({
      url: "announce-of-bec/updateAnnounceOfBecById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertAnnounceOfBec = (data) =>
    this.authFetch({
      url: "announce-of-bec/insertAnnounceOfBec",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteAnnounceOfBecById = (data) =>
    this.authFetch({
      url: "announce-of-bec/deleteAnnounceOfBecById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
